import { gql } from "@apollo/client";

export const COUNTRY_ = gql`
query GetCountries {
    getCountries {
      code
      name
    }
  }`